//export const API_URL = 'https://ibridge-uat.authbridge.com'


//env for production
export const FOLDERPATH = "";
export const FOLDERPATHROUTER = "";
export let CLIENT_LOGOUTURL = '';

//env for local
// export const FOLDERPATH = "";
// export const FOLDERPATHROUTER = "/idemo";
// export let CLIENT_LOGOUTURL = '';


//env for uat
// export const FOLDERPATH = "/idemo";
// export const FOLDERPATHROUTER = "/idemo";
// export let CLIENT_LOGOUTURL = '';

//env for QA and Sandbox
// export const FOLDERPATH = "";
// export const FOLDERPATHROUTER = "";

export const ENVIRONMENT = "LIVE" // LIVEUAT, UAT, LIVE, LOCAL, QA:


export let base_url = "";
export let base_url_client = "";


if (ENVIRONMENT === "LIVEUAT") {
    base_url = window.location.origin + '/candidate-flow';
    base_url_client = window.location.origin + '/client-flow';
    CLIENT_LOGOUTURL = 'https://ibridge-uat.authbridge.com/users/userLogout'
} else if (ENVIRONMENT === "UAT") {
    base_url = window.location.origin + '/idemo/candidate-flow';
    base_url_client = window.location.origin + '/idemo/client-flow';
    CLIENT_LOGOUTURL = 'https://ibridge-uat.authbridge.com/idemo/users/userLogout'
}
else if (ENVIRONMENT === "LIVE") {
    base_url = window.location.origin + '/candidate-flow';
    base_url_client = window.location.origin + '/client-flow';
    CLIENT_LOGOUTURL = 'https://ibridge.authbridge.com/users/userLogout'
}
else if (ENVIRONMENT === "LOCAL") {
    base_url = window.location.origin + '/idemo/candidate-flow';
    base_url_client = 'http://localhost:4000/idemo/client-flow';
    CLIENT_LOGOUTURL = 'https://ibridge-uat.authbridge.com/idemo/users/userLogout'
}
else if (ENVIRONMENT === "QA") {
    base_url = window.location.origin + '/candidate-flow';
    base_url_client = window.location.origin + '/client-flow';
    CLIENT_LOGOUTURL = 'https://ibridge-qa.authbridge.com/users/userLogout'
}